import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { selectObjects } from "~/misc/common";
import moment from "moment";

export default class extends Controller {
  connect() {
    console.log('initMissionActivitiesForm');
    const mission_types = $('#toJs').data('missiontypes');
    refresh();
    $('#mission_activity_mission_type_id').on('change', refresh);
    $('#mission_activity_location_id').on('change', refresh);

    function refresh() {
      const type = selectObjects(mission_types, 'id', $('#mission_activity_mission_type_id').myGetNumValue())[0];
      console.log(type);
      const title = $('.mission_activity_title>label').contents().last()[0] as HTMLElement;
      title.textContent = type.title_name;
      $('#mission_activity_title').attr('placeholder', type.title_placeholder);
      $('#mission_activity_location_id').val() == 2 ? $('.form-group.mission_activity_location_other').show('fast') : $('.form-group.mission_activity_location_other').hide('fast');
      type.has_age ? $('.form-group.mission_activity_age_id').show('fast') : $('.form-group.mission_activity_age_id').hide('fast');
      type.has_participant_num ? $('.form-group.mission_activity_participant_num').show('fast') : $('.form-group.mission_activity_participant_num').hide('fast');
      type.has_student_num ? $('.form-group.mission_activity_student_num').show('fast') : $('.form-group.mission_activity_student_num').hide('fast');
      type.has_parent_num ? $('.form-group.mission_activity_parent_num').show('fast') : $('.form-group.mission_activity_parent_num').hide('fast');
      type.has_group_num ? $('.form-group.mission_activity_group_num').show('fast') : $('.form-group.mission_activity_group_num').hide('fast');
      type.has_preparation ? $('.form-group.mission_activity_preparation_time').show('fast') : $('.form-group.mission_activity_preparation_time').hide('fast');
      type.has_organize ? $('.form-group.mission_activity_main_organizer').show('fast') : $('.form-group.mission_activity_main_organizer').hide('fast');
      type.has_organize ? $('.form-group.mission_activity_involved_organizers').show('fast') : $('.form-group.mission_activity_involved_organizers').hide('fast');
      type.has_organize ? $('.form-group.mission_activity_involved_helpers').show('fast') : $('.form-group.mission_activity_involved_helpers').hide('fast');
      type.has_priest ? $('.form-group.mission_activity_priest_participated').show('fast') : $('.form-group.mission_activity_priest_participated').hide('fast');
      type.has_with_parent ? $('.form-group.mission_activity_with_parent').show('fast') : $('.form-group.mission_activity_with_parent').hide('fast');
    }

    $('#mission_activity_started_at').parent().datetimepicker().on('dp.change', function (e: any) {
      if (e.date == null)
        return;
      const finished_at = $('#mission_activity_finished_at').parent().datetimepicker().data("DateTimePicker");
      if (finished_at.date() == null) {
        finished_at.date(e.date);
      } else if (e.oldDate != null) {
        finished_at.date(e.date.add(moment.duration(finished_at.date() - e.oldDate)));
      }
    });
  }
}